import { GoogleDriveIcon } from '../../../assets/icons/google-drive';
import { createEmbedProvider } from '../factory';

/**
 * Google Drive URL regex pattern
 * Matches: drive.google.com/file/d/FILE_ID, drive.google.com/file/d/FILE_ID/view, etc.
 * Captures the file ID in group 1.
 */
export const GOOGLE_DRIVE_REGEX = /^https?:\/\/drive\.google\.com\/file\/d\/([^/?]+)/i;

export const googleDriveProvider = createEmbedProvider({
  id: 'google-drive',
  label: 'Google Drive',
  icon: <GoogleDriveIcon className="size-5" />,
  regex: GOOGLE_DRIVE_REGEX,
  buildEmbedUrl: (match) => `https://drive.google.com/file/d/${match[1]}/preview`,
});
